module.exports = __webpack_public_path__ + "img/login-img4.95f7a01a.png";